import {createAsyncThunk, createSlice} from '@reduxjs/toolkit'
import {http} from 'hiya-common/src/utils/axios'
import {useSelector} from 'react-redux'
import {
  drawMock1,
  historyMock,
  homepageMock,
  storeExchangeMock,
  replaceMock,
  exchangeMock,
  drawMock2,
} from './mock'

export const get_homepage = createAsyncThunk(
  'homepage',
  async (p: any, store: any) => {
    // return new Promise((res) => {
    //   setTimeout(() => {
    //     res(homepageMock as any)
    //   }, 2000)
    // })

    const resp = await http.post(
      '/live/activity/star_glory',
      {
        ...p,
      },
      {
        store: window.store,
      }
    )
    return resp.data.data
  }
)

export const star_glory_sign_in_select = async (p: any) => {
  // return new Promise((res) => {
  //   setTimeout(() => {
  //     res({
  //       status: 1,
  //     })
  //   }, 2000)
  // })

  const resp = await http.post(
    '/live/activity/star_glory_sign_in_select',
    {
      ...p,
    },
    {
      store: window.store,
    }
  )
  return resp.data.data
}

export const star_glory_sign_in = async (p: any) => {
  // return new Promise((res) => {
  //   setTimeout(() => {
  //     res({
  //       status: 1,
  //     })
  //   }, 2000)
  // })

  const resp = await http.post(
    '/live/activity/star_glory_sign_in',
    {
      ...p,
    },
    {
      store: window.store,
    }
  )
  return resp.data.data
}

export const star_glory_history = async (p: any) => {
  // return new Promise((res) => {
  //   setTimeout(() => {
  //     res(historyMock)
  //   }, 2000)
  // })

  const resp = await http.post(
    '/live/activity/star_glory_history',
    {
      ...p,
    },
    {
      store: window.store,
    }
  )
  return resp.data.data
}

export const star_glory_store_exchange = async (p: any) => {
  // return new Promise((res) => {
  //   setTimeout(() => {
  //     res(storeExchangeMock)
  //   }, 2000)
  // })

  const resp = await http.post(
    '/live/activity/star_glory_store_exchange',
    {
      ...p,
    },
    {
      store: window.store,
    }
  )
  return resp.data.data
}

export const star_glory_view_done = createAsyncThunk(
  'glory_view',
  async (p: any, store: any) => {
    const resp = await http.post(
      '/live/activity/star_glory_view_done',
      {
        ...p,
      },
      {
        store: window.store,
      }
    )
    return resp.data.data
  }
)

export const star_glory_gashapon_draw = createAsyncThunk(
  'gashapon_draw',
  async (p: any, store: any) => {
    // return new Promise((res) => {
    //   setTimeout(() => {
    //     res((p.a ? drawMock1 : drawMock2) as any)
    //   }, 2000)
    // })

    const resp = await http.post(
      '/live/activity/star_glory_gashapon_draw',
      {
        ...p,
      },
      {
        store: window.store,
      }
    )
    return resp.data.data
  }
)

export const star_glory_gashapon_replace = createAsyncThunk(
  'gashapon_replace',
  async (p: any, store: any) => {
    // return new Promise((res) => {
    //   setTimeout(() => {
    //     res(replaceMock as any)
    //   }, 2000)
    // })

    const resp = await http.post(
      '/live/activity/star_glory_gashapon_replace',
      {
        ...p,
      },
      {
        store: window.store,
      }
    )
    return resp.data.data
  }
)

export const star_glory_gashapon_exchange = createAsyncThunk(
  'gashapon_exchange',
  async (p: any, store: any) => {
    // return new Promise((res) => {
    //   setTimeout(() => {
    //     res(exchangeMock as any)
    //   }, 2000)
    // })

    const resp = await http.post(
      '/live/activity/star_glory_gashapon_exchange',
      {
        ...p,
      },
      {
        store: window.store,
      }
    )
    return resp.data.data
  }
)

export type InitialStateType = Record<string, any>

const initialState: InitialStateType = {}

export const PaidActive2025Slice = createSlice({
  name: 'PaidActive2025',
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder.addCase(get_homepage.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
    builder.addCase(star_glory_view_done.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
    builder.addCase(star_glory_gashapon_draw.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
    builder.addCase(star_glory_gashapon_replace.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
    builder.addCase(star_glory_gashapon_exchange.fulfilled, (state, action) => {
      Object.assign(state, action.payload)
    })
  },
})
export default PaidActive2025Slice.reducer

export const useReducerState = () => {
  const data = useSelector((state) => {
    return state.PaidActive2025
  })
  return data
}
